export const GeneralConfig = {
  isDemo: false,
  hasStoreModule: false,
  dateFormat: 'MMM d, yyyy h:mm a',
  language: 'en',
};
